export enum AssetStates {
    READY = "100",
    UNPROCESSED = "101",
    FETCHING = "102",
    FETCHING_ERROR = "201",
    DEPRECATED = "301"
}

export type Filter = {
    type: FilterTypes;
    value?: any;
}

export enum FilterTypes {
    MATCH = 'match',
    PRIME_PLAYER = 'pp',
    ONLINE = 'online',
    OFFLINE = 'offline',
    GROUP = 'group',
    PRESENTATION = 'presentation',
    DT_DISABLED = 'dt_disabled',
}